module.exports = __webpack_public_path__ + "media/vuesrc/apps/public/images/investments/plant-diagram-7612414e6669c11129ca56cf83d0c124.mp4";